import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { claimsActions } from '../../../../store';

import type { AppDispatch, RootState } from '../../../../store';
import type { AdminUpdateClaimStatusData } from '../../../../utils/types';

// Wraps all claim-status-override Redux reads and dispatches for the page, so
// the component never touches react-redux or the claims slice directly.
export const useChangeClaimStatus = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  const claim = useSelector((state: RootState) => state.claims.current);
  const loading = useSelector((state: RootState) => state.claims.loading);

  // Clears the shared current claim, so a claim from the billing pages does
  // not show here on first load. Memoized for use as a useEffect dependency.
  const clearCurrent = useCallback(() => {
    dispatch(claimsActions.updateState({ key: 'current', data: null }));
  }, [dispatch]);

  const fetchClaim = (claimId: string) => {
    dispatch(claimsActions.getClaim({ claimId, getAccessTokenSilently }));
  };

  const updateStatus = (
    claimId: number,
    data: AdminUpdateClaimStatusData,
  ) => dispatch(claimsActions.adminUpdateClaimStatus({ claimId, data, getAccessTokenSilently }));

  return { claim, loading, clearCurrent, fetchClaim, updateStatus };
};
